import { render, staticRenderFns } from "./gtr-badge-printer.vue?vue&type=template&id=56914292&scoped=true"
import script from "./gtr-badge-printer.vue?vue&type=script&lang=ts"
export * from "./gtr-badge-printer.vue?vue&type=script&lang=ts"
import style0 from "./gtr-badge-printer.vue?vue&type=style&index=0&id=56914292&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56914292",
  null
  
)

export default component.exports